export const enClientPortalPlausibilityAnnotations = {
    filterOptions: {
        all: 'All',
        general: 'General',
    },
    newGeneralAnnotationTooltip: 'New general comment',
    onlyThisDraft: 'Only from this draft',
    newerDraftInfo: 'A newer draft exists. Switch to the latest draft to create new comments and replies.',
    notSharedInfo: 'Your appraiser cannot see your comments on this draft until you share them.',
    sectionTitles: {
        general: 'General',
    },
    pdfPageLabel: 'Page {{page}}',
    textBubble: {
        edit: 'Edit',
        deleteAnnotation: 'Delete comment',
        deleteThread: 'Delete entire conversation',
        delete: 'Delete',
        cancel: 'Cancel',
        deletedAnnotationText: 'This comment was deleted.',
        annotationPlaceholder: 'Write a comment',
        annotationPlaceholderWithEllipsis: 'Write a comment...',
        replyPlaceholder: 'Write a reply',
        replyPlaceholderWithEllipsis: 'Write a reply...',
        reply: 'Reply',
        edited: 'edited',
        createdInDraft: 'Created in draft',
        unknownUser: 'Unknown',
        deleteModalTitle: 'Delete comment',
        deleteModalDescription: 'Are you sure you want to delete this comment? This action cannot be undone.',
        deleteModalDescriptionWithReplies: 'Are you sure you want to delete this comment and all replies? This action cannot be undone.',
        notificationTooltip: 'The appraiser will be informed about new comments in the daily report.',
        immediatelyVisible: 'Comment immediately visible to the appraiser',
    },
}
